// Featured property ("Kiemelt Ajánlat") configuration for the /ajanlat landing.
//
// To add a new featured property ("Hot Deal"):
//   1. Add a new entry to `featuredProperties` below.
//   2. Add its `utmCampaigns` values — visitors arriving with a matching
//      `utm_campaign` (or `campaign`) query param land directly on the
//      featured offer screen instead of the hero.
//   3. Point `activeFeaturedPropertyId` at the new entry (or keep multiple
//      active by matching the UTM campaign).
//
// No component code changes are needed to swap in a new property.

export const featuredProperties = {
  kiralyvolgy: {
    id: 'kiralyvolgy',

    // Stored on the lead document + sent to HoppOS.
    featuredPropertyTag: 'Kiralyvolgy_169M',
    // Human-readable label used in email/WhatsApp notifications.
    notificationLabel: 'KIRÁLYVÖLGY / 169 M FT',

    // Visitors arriving with utm_campaign (or campaign) equal to one of these
    // values start directly on the featured offer screen.
    utmCampaigns: ['kiralyvolgy'],

    eyebrow: 'KIEMELT AJÁNLAT',

    // Media — replace `image`/`video` with the real Királyvölgy assets when
    // they arrive. `image: null` renders a clearly-marked placeholder block.
    image: null, // e.g. '/featured/kiralyvolgy-hero.jpg'
    video: '/featured/kiralyvolgy.mp4',
    imageAlt: 'Királyvölgy prémium új otthon',
    placeholderLabel: 'Királyvölgy fotó / videó hamarosan',

    title: 'Királyvölgy • Prémium új otthon',
    specs: '145 m² + 65 m² terasz',
    price: '169.000.000 Ft',

    highlights: ['Panoráma', 'Hőszivattyús fűtés', 'Prémium kivitelezés', 'Átadás akár 8 hónapon belül'],

    primaryCta: 'ÉRDEKEL EZ A HÁZ →',
    secondaryCta: 'INKÁBB SAJÁT HÁZAT TERVEZEK →',

    // Accordion sections — content fields are intentionally empty until the
    // real copy arrives; each entry accepts a plain string or a list.
    accordions: [
      { id: 'about', title: 'AZ INGATLANRÓL', content: null },
      { id: 'technical', title: 'MŰSZAKI TARTALOM', content: null },
      { id: 'handover', title: 'ÁTADÁS ÉS FIZETÉS', content: null },
    ],

    // Short funnel shown to visitors interested in this specific property.
    interestStep: {
      question: 'MIBEN SEGÍTHETÜNK?',
      options: [
        { value: 'szemelyes_megtekintes', label: 'Szeretném személyesen megnézni' },
        { value: 'reszletes_info', label: 'Részletes információt szeretnék' },
        { value: 'finanszirozas', label: 'A fizetési/finanszírozási lehetőségek érdekelnek' },
        { value: 'hasonlo_haz', label: 'Hasonló házat szeretnék máshol' },
        { value: 'visszahivas', label: 'Kérek visszahívást' },
      ],
      gaEventName: 'property_interest_selected',
      gaParamKey: 'property_interest',
    },

    contactStep: {
      headline: 'KÉREK VISSZAHÍVÁST A HÁZRÓL',
      subheadline:
        'Add meg az elérhetőségedet, és felvesszük veled a kapcsolatot a Királyvölgy ingatlannal kapcsolatban.',
      ctaLabel: 'KÉREK VISSZAHÍVÁST A HÁZRÓL',
      footnote: 'Díjmentes • Kötelezettségmentes • Gyors kapcsolatfelvétel',
    },

    // Cross-funnel navigation labels.
    switchToGeneralLabel: 'Ez nem pont nekem való, inkább saját házat építenék',
    switchToFeaturedLabel: 'Inkább a kiemelt Királyvölgy ajánlat érdekel →',

    thankYou: {
      headline: 'KÖSZÖNJÜK! ✓ Megkaptuk az érdeklődésedet.',
      subtext: 'Hamarosan felvesszük veled a kapcsolatot a Királyvölgy ingatlannal kapcsolatban.',
    },
  },
};

// The currently active featured property.
export const activeFeaturedPropertyId = 'kiralyvolgy';

export function getFeaturedProperty() {
  return featuredProperties[activeFeaturedPropertyId] || null;
}

// Resolve which featured property (if any) a visitor should land on based on
// the captured UTM params. Returns the property config or null.
export function resolveFeaturedEntry(utmParams = {}) {
  const campaign = (utmParams.utm_campaign || utmParams.campaign || '').toLowerCase();
  if (!campaign) return null;
  for (const property of Object.values(featuredProperties)) {
    if (property.utmCampaigns.some((c) => c.toLowerCase() === campaign)) {
      return property;
    }
  }
  return null;
}
